import React from "react";
import {
  BaseModal,
  BaseModalHeader,
  BaseModalBody,
} from "@src/common/components";
import CourieButton from "@src/common/components/Button/Button";
import { LayersManager } from "baseui/layer";

export interface SnapshotDiffEntry {
  key: string;
  oldValue?: string;
  newValue?: string;
  changed: boolean;
}

interface ActivityChangeDetailModalProps {
  isOpen: boolean;
  onClose: () => void;
  changedDiffs: SnapshotDiffEntry[];
}

export function ActivityChangeDetailModal({
  isOpen,
  onClose,
  changedDiffs,
}: ActivityChangeDetailModalProps) {
  return (
    <LayersManager zIndex={20}>
      <BaseModal isOpen={isOpen} onClose={onClose}>
        <BaseModalHeader>Compare All Changes</BaseModalHeader>
        <BaseModalBody>
          <div
            className="overflow-x-auto max-h-[60vh]"
            aria-label="Change comparison table"
          >
            <table className="w-full text-base border-collapse">
              <thead>
                <tr>
                  <th
                    className="text-left text-gray-700 dark:text-gray-200 font-semibold p-3 bg-gray-100 dark:bg-gray-700"
                    style={{ fontSize: "1rem" }}
                  >
                    Field
                  </th>
                  <th
                    className="text-left text-gray-700 dark:text-gray-200 font-semibold p-3 bg-gray-100 dark:bg-gray-700"
                    style={{ fontSize: "1rem" }}
                  >
                    Old
                  </th>
                  <th
                    className="text-left text-gray-700 dark:text-gray-200 font-semibold p-3 bg-gray-100 dark:bg-gray-700"
                    style={{ fontSize: "1rem" }}
                  >
                    New
                  </th>
                </tr>
              </thead>
              <tbody>
                {changedDiffs.map(({ key, oldValue, newValue }, idx) => (
                  <tr
                    key={key}
                    className={
                      idx % 2 === 0
                        ? "bg-white dark:bg-gray-800"
                        : "bg-gray-50 dark:bg-gray-800/50"
                    }
                  >
                    <td
                      className="p-3 text-gray-700 dark:text-gray-200 whitespace-nowrap"
                      style={{ fontSize: "1rem" }}
                    >
                      {key}
                    </td>
                    <td
                      className="p-3 text-gray-500 dark:text-gray-400"
                      style={{ fontSize: "1rem" }}
                    >
                      {oldValue == null || oldValue === "null"
                        ? "-"
                        : String(oldValue)}
                    </td>
                    <td
                      className="p-3 text-blue-800 dark:text-blue-300 font-bold"
                      style={{ fontSize: "1rem" }}
                    >
                      {newValue == null || newValue === "null"
                        ? "-"
                        : String(newValue)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="flex justify-end mt-6">
            <CourieButton
              color="gray"
              size="md"
              aria-label="Close comparison modal"
              onClick={onClose}
            >
              Close
            </CourieButton>
          </div>
        </BaseModalBody>
      </BaseModal>
    </LayersManager>
  );
}
